import { createContext } from 'react'

type DebugContextType = { 
    debugEnabled: boolean;
    toggleDebugMode?: () => void 
}

const initialContext = { debugEnabled: false } as DebugContextType

export const DebugContext = createContext<DebugContextType>(initialContext);

